<template>
  <b-container class="my-5">
    <b-row>
      <b-col xl="12">
        <b-card no-body>
          <h3 class="card-header bg-white">Mis consultorios</h3>
          <b-card-body>
            <div class="text-right mb-3">
              <b-button to="/offices/new" variant="primary">Agregar</b-button>
            </div>
            <b-card no-body class="mb-3" v-for="office in offices.data" v-bind:key="office._id">
              <b-card-body>
                <b-card-title class="text-primary">{{ office.venue }}</b-card-title>
                <b-row>
                  <b-col md="4">
                    <font-awesome-icon class="text-success" :icon="['fas', 'briefcase-medical']"/>
                    {{ office.specialities.join(', ') }}
                  </b-col>
                  <b-col md="4" class="text-truncate">
                    <font-awesome-icon class="text-success" :icon="['fas', 'envelope-square']"/>
                    {{ office.email }}
                  </b-col>
                  <b-col md="2">
                    <font-awesome-icon class="text-success" :icon="['fas', 'mobile-alt']"/>
                    {{ office.phone }}
                  </b-col>
                  <b-col md="2">
                    <font-awesome-icon class="text-success" :icon="['fas', 'dollar-sign']"/>
                    {{ office.price }}
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col md="12">
                    <b-link v-bind:to="'/offices/' + office.id" class="card-link outline-secondary">Ver</b-link>
                    <b-link href="#" class="card-link" @click="onUpdateOffice(office)">Editar</b-link>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
            <div>
              <ul class="pagination justify-content-center mb-3">
                <li class="page-item">
                  <a class="page-link" to="/directory" tabindex="-1" aria-label="Previous">
                    <span aria-hidden="true"> &laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" to="/directory/1">1</a>
                </li>
                <li class="page-item">
                  <a class="page-link" to="/directory">2</a>
                </li>
                <li class="page-item">
                  <a class="page-link" to="/directory">3</a>
                </li>
                <li class="page-item">
                  <a class="page-link" to="/directory/4" tabindex="+1" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              </ul>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col xl="12">
        <adsense
          ad-slot="9585150092"
          ad-format="auto"
          ad-client="ca-pub-1844310477126911"
          ad-style="display:block">
        </adsense>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Adsense from '@/components/Adsense'

export default {
  components: { Adsense },
  name: 'Offices',
  data () {
    return {
      offices: {
        data: [
          {
            id: 'xxxxxxxxxxx',
            doctor: {
              id: 'sssssss',
              name: 'Josué Cámara Fernández'
            },
            address: {
              stateOrRegion: 'Ciudad de Mexico',
              city: 'Ciudad de Mexico',
              countryCode: 'MX',
              postalCode: 97315,
              addressLine1: 'Vicente Suarez 153',
              districtOrCounty: 'Condesa'
            },
            fullAddress: 'Vicente Suarez 153, Condesa, Ciudad de México',
            venue: 'Vicente Suarez 153, Condesa, Ciudad de México',
            phone: '5534448707',
            price: 950,
            email: 'consultorio@listadomedico.com',
            specialities: ['cardiología', 'oncología']
          }, {
            id: 'xxxxxxxxxxx',
            doctor: {
              id: 'sssssss',
              name: 'Josué Cámara Fernández'
            },
            address: {
              stateOrRegion: 'Yucatán',
              city: 'Molas',
              countryCode: 'MX',
              postalCode: 97315,
              addressLine1: 'Calle 18 No 100',
              districtOrCounty: 'Mérida'
            },
            fullAddress: 'Calle 18 No 100, Molas, Yucatan',
            venue: 'Calle 18 No 100, Molas, Yucatan',
            phone: '5534448707',
            price: 950,
            email: 'consultas@molas.org',
            specialities: ['cardiología', 'oncología']
          }, {
            id: 'xxxxxxxxxxx',
            doctor: {
              id: 'sssssss',
              name: 'Josué Cámara Fernández'
            },
            address: {
              stateOrRegion: 'Ciudad de Mexico',
              city: 'Ciudad de Mexico',
              countryCode: 'MX',
              postalCode: '03140',
              addressLine1: 'Gonzalez de Cossio 22',
              districtOrCounty: 'Del valle centro'
            },
            fullAddress: 'Gonzalez de Cossio 22, Del Valle Centro',
            venue: 'Gonzalez de Cossio 22',
            phone: '5534448707',
            price: 950,
            email: 'delvalle@molas.org',
            specialities: ['cardiología', 'oncología']
          }
        ],
        total: 1
      }
    }
  },
  methods: {
    onUpdateOffice (office) {
    }
  }
}
</script>
